export default {
  name: 'home',
  data() {
    return {}
  },
}



// WEBPACK FOOTER //
// ./src/pages/Home/script.js?vue&type=script&lang=js&